import { PaginationProps } from 'antd/es/pagination';
import { useMemo } from 'react';
import { useConfiguration } from '../../configuration';
import { DEFAULT_TABLE_PAGE_SIZE } from '../tanstacktable';

const pageSizeOptions = [50, 100, 200, 500];
const devPageSizeOptions = [10, ...pageSizeOptions];
export const defaultPaginationState: PaginationProps = {
  current: 1,
  pageSize: DEFAULT_TABLE_PAGE_SIZE,
};

export const usePageSizeOptions = () => {
  const { environment } = useConfiguration();
  return useMemo(() => {
    if (environment === 'local' || environment === 'dev') {
      return devPageSizeOptions;
    }

    return pageSizeOptions;
  }, [environment]);
};
